import { useQuery } from '@tanstack/react-query';
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import ConfirmationModal from '../../Shared/ConfirmationModal/ConfirmationModal';
import Loading from '../../Shared/Loading/Loading';

const ManageDoctors = () => {
    const [deletingDoctor, setDeletingDocotr] = useState(null);
    const closeModal = () => {
        setDeletingDocotr(null)
    }
    console.log('inside manage doctor component', localStorage.getItem('accessToken'))
    const { data: doctors, isLoading, refetch } = useQuery({
        queryKey: ['doctors'],
        queryFn: async () => {
            try {
                const rest = await fetch('https://doctors-portal-server-chi-two.vercel.app/doctors', {
                    headers: {
                        authorization: `bearer ${localStorage.getItem('accessToken')}`
                    }
                });
                const data = await rest.json();
                console.log(data)
                return data;
            }
            catch (error) {

            }
        }
    })

    if (isLoading) {
        return <Loading></Loading>
    }

    const handleDoctorDelete = (doctor) => {
        // console.log('Deleting DOCTOR with id: ', doctor._id)
        fetch(`https://doctors-portal-server-chi-two.vercel.app/doctors/${doctor._id}`, {
            method: 'DELETE'
        })
            .then(res => res.json())
            .then(data => {
                console.log(data)
                if (data.deletedCount > 0) {
                    toast.error(`Doctor ${doctor.name} deleted successfully.`)
                    refetch();
                }
            })

    }

    if (isLoading) {
        return <Loading></Loading>
    }

    return (
        <div>
            <h1 className='text-3xl my-5'>Manage Doctors: {doctors?.length}</h1>
            <div className="overflow-x-auto">
                <table className="table w-full">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Avatar</th>
                            <th>Name</th>
                            <th>Specialty</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            doctors?.map((doctor, i) => <tr
                                key={doctor._id}
                            >
                                <th>{i + 1}</th>
                                <td><div className="avatar">
                                    <div className="w-12 rounded-full">
                                        <img src={doctor.img} alt='' />
                                    </div>
                                </div>
                                </td>
                                <td>{doctor.name}</td>
                                <td>{doctor.specialty}</td>
                                <td>
                                    <label onClick={() => setDeletingDocotr(doctor)} htmlFor="confirmation-modal" className="btn btn-sm btn-error">Delete</label>
                                    {/* <button onClick={() => handleDoctorDelete(doctor)} className="btn btn-sm btn-error">X</button> */}
                                </td>
                            </tr>)
                        }
                    </tbody>
                </table>
            </div>
            {
                deletingDoctor && <ConfirmationModal
                    title={`Are you sure want to delete?`}
                    message={`If you delete ${deletingDoctor.name}. It cannot be undo.`}
                    successAction={handleDoctorDelete}
                    modalData={deletingDoctor}
                    closeModal={closeModal}
                    successButtonName="Delete"
                ></ConfirmationModal>
            }
        </div>
    );
};

export default ManageDoctors;